/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Button } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getManufacturerList,
  getZeroURAMaxQtr,
  getZeroURAResult,
  setZeroURAReport,
} from '../Store/action';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { ManufactureTableHead } from './tableHeads';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import * as Constants from '../../../../SharedModules/AppConstants';
import {
  convertToFourDigitYear,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';
import {
  REBATE_SELECT,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
  QUARTER_VALUE_REQUIRED
} from '../../../../SharedModules/Errors/constantMessageData';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function ReqZeroURA(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    // selectedPlanType,
    // rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    manufacturerList: resultanufacturerList,
    // isAllManufacturersSelected: isAllManufacturersSelectedValue,
    // scrollDownManufacturers: scrollDownManufacturersValue,
    searchResult,
    selectedRowIndexValue,
    // quarterValue,
    zeroUraMaxQuarter,
    searchScreenVar: {
      rebateProgramValue,
      selectedPlanType,
      quarterValue,
      isAllManufacturersSelected: isAllManufacturersSelectedValue,
      scrollDownManufacturers: scrollDownManufacturersValue,
    },
  } = useSelector((state) => state?.sharedState?.ZeroURAReducer);
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  // To know that search button is pressed
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [errorList, setErrorList] = React.useState(errors);
  const [isAllManufacturersSelected, setIsAllManufacturersSelected] =
    React.useState(isAllManufacturersSelectedValue);

  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [manufacturerSelectedId, setManufacturerSelectedId] =
    React.useState('ALL');
  const [manufacturerSelectedName, setManufacturerSelectedName] =
    React.useState('');
  const [quarter, setQuarter] = React.useState(quarterValue);
  const [scrollDownManufacturers, setScrollDownManufacturers] = React.useState(
    scrollDownManufacturersValue
  );
 const [selectedRowIndex, setSelectedRowIndex] = React.useState(
  selectedRowIndexValue || 0 
);

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  React.useEffect(() => {
    dispatch(getZeroURAMaxQtr());
  }, []);

  // To set the quarter varaible
  React.useEffect(() => {
    if (zeroUraMaxQuarter) {
      setQuarter(quarterValue || zeroUraMaxQuarter);
    }
  }, [zeroUraMaxQuarter]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);
          
  //remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [zeroUraMaxQuarter, rebateProgram, planTypeList, planType, resultanufacturerList, quarter, isAllManufacturersSelected, scrollDownManufacturers, fullScreenView, selectedRowIndexValue]);

  const rebatepgmDropdown = async (planType) => {
    dispatch(setSearchInput({ errors: [] }));
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList?.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // To get manufacturer List
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);

  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultanufacturerList]);

  // To change the manufacturer grid as per the plan type selection
  const handleOnChangeEvent = (value, name) => {
    dispatch(setSearchInput({ errors: [] }));
    if (name === 'planTypeCd') {
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
  };

  // function to conver 2 digit year to 4 digit ear
  const convertTo4DigitQtr = (value) => {
    const tempValue = value.split('Q');

    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue.join('Q');
  };

  // Handle onblur events for date and quarter
  const handleOnBlur = (type, value) => {
  let localErrors = errorList;

  if (type === "qtr") {
    localErrors = localErrors.filter((error) => error.field !== "qtr");

    if (!value || value.trim() === "") {
      localErrors.push({
        field: "qtr",
        message: QUARTER_VALUE_REQUIRED,
      });
    } else {
      const qtrErr = validateQuarter(value, "qtr", true);
      if (qtrErr.length === 0) {
        const qtr = value.length === 4 ? convertTo4DigitQtr(value) : value;
        setQuarter(qtr);
      } else {
        localErrors = [...localErrors, ...qtrErr];
      }
    }
  }
  setErrorList(localErrors);
  dispatch(setSearchInput({ errors: localErrors }));
};

  // On selection of the row data
  const onSelectionChanged = (e) => {
    dispatch(setSearchInput({ errors: [] }));
    // let manuError = [];
    const selectedRows = e.api?.getSelectedRows();
    if (selectedRows.length) {
      setManufacturerSelectedId(selectedRows[0]?.mfgId);
      setManufacturerSelectedName(selectedRows[0]?.mfgName);
    }
    const errors = errorList.filter((error) => error.field !== 'manufacturer');
    setErrorList([...errors]);
    // setErrorList(manuError);
  };

  const handleSearchClick = (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = ''
  ) => {
    let allErrors = [];
    const manuError = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
     if (
      (quarter === '' || quarter === undefined)
    ) {
      allErrors.push({
        field: 'qtr',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (
      !onDoubleClick &&
      (manufacturerSelectedId === '' || manufacturerSelectedId === undefined)
    ) {
      allErrors.push({
        field: 'manufacturer',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }
    if (onDoubleClick && selectedRowOnDoubleClick === '') {
      allErrors.push({
        field: 'manufacturer',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }

    allErrors = [...allErrors, ...errorList];

    setErrorList(allErrors);

    let tempIndexes = '';
    if (onDoubleClick) {
      manufacturerList.forEach((item, index) => {
        if (
          selectedRowOnDoubleClick &&
          selectedRowOnDoubleClick?.mfgId === item.mfgId
        ) {
          tempIndexes = index;
        }
      });
    }
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList?.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        rebateProgramName,
        rebateProgrameName,
        manufacturerSelectedId: onDoubleClick
          ? selectedRowOnDoubleClick?.mfgId
          : manufacturerSelectedId,
        manufacturerSelectedName: onDoubleClick
          ? selectedRowOnDoubleClick?.mfgName
          : manufacturerSelectedName,
        quarterValue: quarter,
        isAllManufacturersSelected,
        scrollDownManufacturers,
        selectedRowIndexValue: onDoubleClick ? tempIndexes : selectedRowIndex,
        searchScreenVar: {
          rebateProgramValue: rebateProgram,
          selectedPlanType: planType,
          quarterValue: quarter,
          isAllManufacturersSelected,
          scrollDownManufacturers,
          rebateProgrameName,
        },
      })
    );

    if (allErrors.length === 0) {
      dispatch(setZeroURAReport([]));
      setSearchClicked(true);
      dispatch(
        getZeroURAResult({
          rebateProgramCd: rebateProgram,
          quarter: quarter,
          mfg: onDoubleClick
            ? selectedRowOnDoubleClick?.mfgId
            : manufacturerSelectedId,
        })
      );
    }

    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */
    if (allErrors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
    if (isSearchClicked && errors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [errors]);

  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/dispZeroURA',
      value: 'Display Zero URA Rpt',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props.history) {
      props.history.push({
        pathname: '/dispZeroURA',
      });
    }
    dispatch(clearReduxForFilterAndSort('/dispZeroURA'));
  }

  const cellClickedListener = (e) => {
    setManufacturerSelectedId(e?.data);
    handleSearchClick(null, true, e?.data);
  };

  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  React.useEffect(() => {
  if (manufacturerList?.length > 0 && selectedRowIndex === undefined) {
    const firstRow = manufacturerList[0];
    setManufacturerSelectedId(firstRow.mfgId);
    setManufacturerSelectedName(firstRow.mfgName);
    setSelectedRowIndex(0);
  }
}, [manufacturerList]);
  return (
    <div className="tabs-container">
      {!fullScreenView && (
        <div className="tab-body">
          <Spinner load={isLoading} />

          <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />

          <CustomSeparator parent1="State Reports" parent2="Zero URA" />
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="Curr_Zero_PlanType"
                id="filter-plan-by-radio-btn-action"
                labelName="Plan Type"
                required
                optionList={radioList || []}
                defaultValue={planType}
                filterAction={(value) => {
                  setPlanType(value);
                  setRebateProgram('-1');
                  handleOnChangeEvent(value, 'planTypeCd');
                  const errors = errorList.filter(
                    (error) => error.field !== 'rebateProgram'
                  );
                  setErrorList([...errors]);
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4">
              <>
                <Fieldset label="Rebate Program" required>
                  <div>
                    <SelectBoxComponent
                      data-testid="Curr_Zero_RebateProgram"
                      id="filter-plan-by-radio-btn-action"
                      labelName="Rebate Program"
                      required
                      select
                      selectOne
                      optionList={selectList || []}
                      defaultValue={rebateProgram}
                      filterAction={(value) => {
                        setRebateProgram(value);
                        setRebateProgramName(value);
                        const errors = errorList.filter(
                          (error) => error.field !== 'rebateProgram'
                        );
                        setErrorList([...errors]);
                      }}
                      isError={
                        errorList.find(
                          (error) => error.field === 'rebateProgram'
                        )?.message
                      }
                    />
                  </div>
                </Fieldset>
              </>
            </div>
            <div className="col-3 mt-2">
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  label="Quarter"
                  id="qtrreq"
                  data-testid="req-NDC-payment-quarter"
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{ maxLength: 6, id: 'qtrreq' }}
                  required
                  name="qtr"
                  value={quarter}
                  error={
                    errorList.filter((error) => error.field === 'qtr')?.length >
                    0
                      ? 'mandate-fields'
                      : ''
                  }
                  helperText={
                    errorList.find((error) => error.field === 'qtr')?.message
                  }
                  className="mandate-fields"
                  onBlur={(e) => handleOnBlur('qtr', e.target.value)}
                  onChange={(e) => {
                    const { value } = e.target;
                    setQuarter(value.toUpperCase());
                    const localErrors = errorList.filter(
                      (error) => error.field != 'qtr'
                    );
                    setErrorList(localErrors);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row ml-2 mt-3">
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAllManufacturersSelected}
                    color="primary"
                    name="allManufacturers"
                    onChange={async (e) => {
                      setIsAllManufacturersSelected(
                        !isAllManufacturersSelected
                      );

                      setScrollDownManufacturers(!scrollDownManufacturers);
                      if (!isAllManufacturersSelected) {
                        setManufacturerSelectedId('ALL');
                      } else {
                        setManufacturerSelectedId('');
                      }

                      const elem = document.getElementById('abc11');
                      if (elem && scrollDownManufacturers) {
                        await Promise.resolve()
                        // setTimeout(() => {
                          elem.scrollIntoView(); 
                        // }, 1000);
                      }
                      const errors = errorList.filter(
                        (error) => error.field !== 'manufacturer'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'manufacturer')
                        ?.message
                    }
                  />
                }
                label="All Manufacturers"
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: 15 }}>
            <div className="btn-wrapper col-12">
              <Button
                data-testid="view_detail_ia"
                onClick={handleSearchClick}
                className="btn btn-success btn-search float-right"
              >
                <SVGComponent iconName="Icon-search" /> Search
              </Button>
            </div>
          </div>
        </div>
      )}
      <div className="row" id="abc11">
        {!isAllManufacturersSelected && (
          <div className="col-12 unallocated">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              selectRowIndex={selectedRowIndex}
              cellClickedListener={cellClickedListener}
              rowData={manufacturerList || []}
              helpMessage="* On Double Click of Results, system should navigate to Detail page"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={ManufactureTableHead}
              rowSelection="single"
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fileName="Manufacturer List"
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              exportFile
              hideColumnsInPdf
            />
          </div>
        )}
      </div>
    </div>
  );
}
